import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { batchQuoteRemovedThunk } from 'state/batchForm/batchForm.thunks';
import type { EpicWithThunk } from 'state/state.common';

export function removeBatchQuote(): EpicWithThunk {
  return (action$, state$, { selectors: { getBatchFormInfos } }) => {
    const formInputChangeFormId$ = action$.pipe(
      ofType('FORM_INPUT_DATA_CHANGED'),
      map(action => [action.tabId, action.formId]),
    );

    const formEnrichmentRequested$ = action$.pipe(
      ofType('FORM_ENRICHMENT_REQUESTED'),
      map(action => [action.tabId, action.formId]),
    );

    return merge(formInputChangeFormId$, formEnrichmentRequested$).pipe(
      withLatestFrom(state$),
      mergeMap(([[tabId, formId], state]) => {
        const quoteId = getBatchFormInfos(state, formId)?.quoteId;
        return quoteId ? of(batchQuoteRemovedThunk(tabId, [formId])) : EMPTY;
      }),
    );
  };
}
